"use strict";

const mimeMC = "application/vnd.joylife.question.multiplechoice";

class QuestionType {

    private _typeString: string;

    constructor(typeString) {
        this._typeString = typeString;
    }

    isPlaintext() {
        return this._typeString && (this._typeString.localeCompare("text/plain") === 0);
    }

    isMultipleChoice() {
        return this._typeString && (this._typeString.localeCompare(mimeMC) === 0);
    }

    toString() {
        return this._typeString;
    }

    public static plainText = new QuestionType("text/plain");
    public static multipleChoice = new QuestionType(mimeMC);
}

export default QuestionType;